export default __webpack_public_path__ + "static/media/threebigcards_services_3.3ca64893.png";